import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import { SocialIcons } from 'inside-out/components/shared/socialIcons';

import { descriptionToHex } from 'inside-out/managers/colourManager';

import {
	wrapperStyle,
	innerWrapperStyle,
	titleStyle,
	textStyle,
	cardsWrapStyle,
	cardsSectionStyle,
	contactWrapStyle,
	contactColumnStyle,
	contactContentStyle,
	contactTitleStyle,
} from 'inside-out/page-styles/get-involved';

import { Cards } from 'inside-out/components/shared/cards';
import { ArrowLink } from 'inside-out/components/shared/arrowLink';
import { ColouredCard } from 'inside-out/components/shared/cards/colouredCard';
import {
	contentSection,
	tabletPortraitMinWidthBreakpoint,
	mobileMinWidthBreakpoint,
	tabletLandscapeMinWidthBreakpoint,
} from 'inside-out/global-styles';

export default class GetInvolvedPage extends React.PureComponent {
	static propTypes = {
		data: PropTypes.shape({
			page: PropTypes.shape({
				edges: PropTypes.arrayOf(
					PropTypes.shape({
						node: PropTypes.shape({
							heading: PropTypes.string.isRequired,
							body: PropTypes.string.isRequired,
							tiles: PropTypes.arrayOf(
								PropTypes.shape({
									heading: PropTypes.string,
									body: PropTypes.string,
									link_destination: PropTypes.string,
									colour: PropTypes.string,
								})
							),
							spread_the_word_heading: PropTypes.string.isRequired,
							spread_the_word_body: PropTypes.string.isRequired,
							get_in_touch_heading: PropTypes.string.isRequired,
							get_in_touch_body: PropTypes.string.isRequired,
							get_in_touch_link_text: PropTypes.string.isRequired,
							get_in_touch_link_url: PropTypes.string.isRequired,
						}).isRequired,
					})
				).isRequired,
			}).isRequired,
		}).isRequired,
	};

	render() {
		const pageSettings = this.props.data.page.edges[0].node;

		return (
			<div className={wrapperStyle}>
				<Helmet title={pageSettings.heading}>
          <meta property="og:type" content="website"/>
          <meta property="og:title" content={pageSettings.heading}/>
          <meta name="description" content="Get involved in supporting the lives of Australians living with, or affected by an eating disorder. You can get involved by donating or holding a fundraiser, by volunteering your time or finding employment in the eating disorder sector."/>
          <meta property="og:description" content="Get involved in supporting the lives of Australians living with, or affected by an eating disorder. You can get involved by donating or holding a fundraiser, by volunteering your time or finding employment in the eating disorder sector."/>
        </Helmet>

				<section className={contentSection('#fff')}>
					<div className={innerWrapperStyle}>
						<header>
							<h1 className={titleStyle}>{pageSettings.heading}</h1>
						</header>
						<div className={textStyle} dangerouslySetInnerHTML={{ __html: pageSettings.body }} />
					</div>
				</section>

				<div className={cardsWrapStyle}>
					<div className={innerWrapperStyle}>
						<section className={cardsSectionStyle}>
							<Cards
								columns={4}
								scrollable={false}
								columnsAt={{
									[`min-width: ${mobileMinWidthBreakpoint}`]: 1,
									[`min-width: ${tabletPortraitMinWidthBreakpoint}`]: 2,
									[`min-width: ${tabletLandscapeMinWidthBreakpoint}`]: 4,
								}}
							>
								{pageSettings.tiles.map((tile, i) => (
									<ColouredCard
										id={i}
										key={i}
										background={descriptionToHex(tile.colour)}
										to={tile.link_destination}
										title={tile.heading}
										body={tile.body}
										minHeight={276}
										arrow={true}
									/>
								))}
							</Cards>
						</section>
					</div>
				</div>
				<section className={contentSection('#fff', 0)}>
					<div className={innerWrapperStyle}>
						<div className={contactWrapStyle}>
							<div className={contactColumnStyle}>
								<header>
									<h1 className={contactTitleStyle}>{pageSettings.spread_the_word_heading}</h1>
								</header>
								<div
									className={contactContentStyle}
									dangerouslySetInnerHTML={{ __html: pageSettings.spread_the_word_body }}
								/>
								<SocialIcons mode="share" width={50} inline={true} />
							</div>
							<div className={contactColumnStyle}>
								<header>
									<h1 className={contactTitleStyle}>{pageSettings.get_in_touch_heading}</h1>
								</header>
								<div
									className={contactContentStyle}
									dangerouslySetInnerHTML={{ __html: pageSettings.get_in_touch_body }}
								/>
								<ArrowLink to={pageSettings.get_in_touch_link_url}>
									{pageSettings.get_in_touch_link_text}
								</ArrowLink>
							</div>
						</div>
					</div>
				</section>
			</div>
		);
	}
}

export const query = graphql`
	query GetInvolvedPageQuery {
		page: allContentJson(filter: { id: { regex: "/content\\/get-involved-page\\.json/" } }) {
			edges {
				node {
					heading
					body
					tiles {
						heading
						body
						link_destination
						colour
					}
					spread_the_word_heading
					spread_the_word_body
					get_in_touch_heading
					get_in_touch_body
					get_in_touch_link_text
					get_in_touch_link_url
				}
			}
		}
	}
`;



// WEBPACK FOOTER //
// ./src/pages/get-involved/index.js